export const linkData = [
  {
    id: 1,
    text: "forside",
    path: "/",
  },
  {
    id: 2,
    text: "menu",
    path: "/products",
  },
  {
    id: 3,
    text: "kurv",
    path: "/cart",
  },
  {
    id: 4,
    text: "om os",
    path: "/about",
  },
  {
    id: 5,
    text: "kontakt",
    path: "/contact",
  },
  {
    id: 6,
    text: "handelsbetingelser",
    path: "/handelsbetingelser",
  },
  {
    id: 7,
    text: "privatlivs politik",
    path: "/privatlivspolitik",
  },
];
